export default {
  'my-investor': 'My Clients',
  'page-table': {
    search: 'Search',
    reset: 'Reset',
    placeholders: {
      search: 'Client ID / Name',
      country: 'Country of Residence',
      role: 'Role',
      ibStatus: 'IB Status',
      depositStatus: 'Deposit Status',
      registerTime: 'Registration time',
      lastTradeTime: 'Last trade time',
    },
    tags: {
      direct: 'Direct',
      agent: 'IB',
    },
    ibStatusText: {
      '9': 'Approved',
      '-1': 'Rejected',
      '1': 'Pending',
      '0': 'To be signed',
      other: '--',
    },
    kycStatusText: {
      '9': 'Verified',
      other: 'Unverified',
    },
    depositStatusText: {
      '1': 'Deposited',
      '2': 'Not deposited',
      '3': 'No deposit for 30 days',
    },
    roleOptions: {
      agent: 'IB',
      direct: 'Direct',
    },
    ibStatusOptions: {
      '-1': 'Rejected',
      '0': 'Not submitted',
      '1': 'Pending',
      '9': 'Completed',
    },
    depositStatusOptions: {
      '1': 'Deposited',
      '2': 'Not deposited',
      '3': 'No deposit for 30 days',
    },
    columns: {
      'member-id': 'Member ID',
      nickname: 'Nickname',
      realname: 'Name',
      email: 'Email',
      country: 'Country',
      'register-time': 'Registration Time',
      'parent-info': 'Superior Info',
      'account-type': 'Account Type',
      'ib-status': 'IB Status',
      'kyc-status': 'KYC Status',
      'last-trade-time': 'Last Trade Time',
      'deposit-status': 'Deposit Status',
      deposit: 'Deposit',
      withdraw: 'Withdrawal',
      'net-deposit': 'Net Deposit',
      'transfer-amount': 'Transfer Amount',
      'total-amount': 'Total Assets',
      'mt-numbers': 'MT Accounts',
      'mt-volume': 'MT Volume',
      'commission-income': 'Commission Income',
    },
  },
  'page-tree': {
    placeholder: 'Client ID / Name',
    tags: {
      direct: 'Direct',
      agent: 'IB',
    },
    popover: {
      setCommission: 'Set Commission',
      setAgent: 'Set Agent',
    },
  },
  'member-assets': {
    title: 'Member Assets',
    'total-assets': 'Total Assets',
    wallet: 'Wallet Account',
    trading: 'Trading Account',
    'gtc-copy': 'GTC Copy Account',
    pamm: 'PAMM Account',
  },
  'application-agency': {
    title: 'Apply for Agent',
    'account-type': 'Account Type',
    'input-placeholder': 'Please enter',
    'apply-success': 'Application succeeded',
    'apply-failed': 'Application failed',
  },
  'set-commission': {
    title: 'Set Commission',
    columns: {
      rule: 'Commission Rule',
      'my-commission': 'My Commission',
      'lower-agent-commission': 'Lower Agent Commission - linping',
      'extra-commission': 'Lower Agent Extra Commission - linping',
      actions: '',
    },
    error: {
      serverConfig: 'Server list is empty',
    },
    unit: {
      fixed: 'USD/lot',
      percent: '%',
    },
    buttons: {
      edit: 'Edit',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    'set-success': 'Set successfully',
  },
  'mt-account': {
    title: 'MT Account',
    columns: {
      'account-nickname': 'Account Nickname',
      'mt-account': 'MT Account',
      'mt-server': 'MT Server',
      'account-type': 'Account Type',
      'account-balance': 'Account Balance',
      time: 'Time',
    },
  },
}
